import * as requests from "@app/components/checkout/requests";
import CheckoutApi from "@support/checkoutApi";

/**
 * @type {Module<ShippingMethodsState>}
 */
const shippingMethods = {
    namespaced: true,
    state: {
        shipping_methods: [],
        selected_shipping_method: null,
    },
    mutations: {
        setShippingMethods: (s, p) => s.shipping_methods = p,
        setSelectedShippingMethod: (s, p) => s.selected_shipping_method = p,
    },
    actions: {
        fetchShipping(context, asPromise) {
            const {zip_code, city, country, state} = context.rootState.shipping;
            const items = context.rootGetters["checkout/items"];

            const containsShippableItems = items.filter(function(item) {
              const shippingType = item.options.shipping_type ? item.options.shipping_type : 'ship';

              return 'ship' === shippingType;
            }).length > 0;

            if (!containsShippableItems) {
              context.commit('setShippingMethods', []);
              return;
            }

            if (!zip_code || !city || !country || items.length === 0) {
                context.commit('setShippingMethods', []);
                return;
            }

            let params = {
                zip_code,
                city,
                country: country || 'US',
            };

            if (state) {
                params['state'] = state;
            }

            return asPromise === true ? requests.fast_shipping(context, params) : requests.shipping(context, params);

        },
        setSelectedShippingMethod({dispatch, commit}, shippingMethod) {
            console.debug("Set shipping method");

            commit('setSelectedShippingMethod', shippingMethod);

            if (!shippingMethod) {
                return;
            }
            const {service_code, package_code, price, label, original_price} = shippingMethod;

            return CheckoutApi.setShippingMethod({
                price,
                service_code,
                package_code,
                method_preview: label,
                original_price
            }).then(r => {
                dispatch('updateCheckout', r.data, {root: true});
                commit('shipping/setServiceCode', service_code, {root: true});
                commit('shipping/setPackageCode', package_code, {root: true});
                commit('shipping/setShippingMethodPreview', label, {root: true});
                commit('shipping/setPriceTotal', price, {root: true});
            }).catch(e => {
                console.error(e)
            });
        }
    },
};

export default shippingMethods;
